var LAUNCH_DOMAIN = 'launch';
var DOCUMENT_LIBRARY_EVENT = 'document_library';
var DOCUMENT_EVENT = 'document';
var BROWSER_EVENT = 'iab';
export var documentLibrary = function (category) { return ({
    domain: LAUNCH_DOMAIN,
    eventType: DOCUMENT_LIBRARY_EVENT,
    data: {
        category: category,
    },
}); };
export var document = function (documentId, pageSlug) { return ({
    domain: LAUNCH_DOMAIN,
    eventType: DOCUMENT_EVENT,
    data: {
        product_id: documentId,
        page_slug: pageSlug,
    },
}); };
/** Opens the provided url in a web browser
 *
 * @param url The url to open
 * @param external
 * Whether to open the url in a webview inside the app, or in the external system browser
 */
export var browser = function (url, external) {
    if (external === void 0) { external = false; }
    return ({
        domain: LAUNCH_DOMAIN,
        eventType: BROWSER_EVENT,
        data: {
            url: url,
            settings: {
                launch_type: external ? 'external' : 'default',
            },
        },
    });
};
//# sourceMappingURL=launch.js.map